'use client'

import { ComponentProps, ReactNode } from 'react'

import { Cell, Navigation, Text } from '@vinted/web-ui'

type Props = ComponentProps<typeof Navigation> & {
  bodyText: ReactNode
}

const BaseConversationHeader = ({ bodyText, ...props }: Props) => (
  <div className="conversation-header">
    <Navigation
      {...props}
      body={
        <Cell styling="tight">
          <Text as="h2" type="title" text={bodyText} theme="amplified" />
        </Cell>
      }
    />
  </div>
)

export default BaseConversationHeader
